import { render } from "./product-outfits.vue?vue&type=template&id=38c78f58"
import script from "./product-outfits.vue?vue&type=script&lang=js"
export * from "./product-outfits.vue?vue&type=script&lang=js"

import "./product-outfits.vue?vue&type=style&index=0&id=38c78f58&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__